import {IChapterMark} from '@services/live-events/live-events.model';
import {convertTimestampToSeconds} from '@utils/convertTimestampToSeconds';

export interface IChapterCue {
    startTime: number;
    endTime: number;
    title: string;
    description: string;
    text: string;
}

export const parseChapterMarks = (
    chapterMarks: IChapterMark[] = [],
): IChapterCue[] => {
    return chapterMarks.map((chapterMark: IChapterMark) => ({
        startTime: convertTimestampToSeconds(chapterMark.start_timestamp),
        endTime: convertTimestampToSeconds(chapterMark.end_timestamp),
        title: chapterMark.chapter_title,
        text: chapterMark.chapter_title,
        description: chapterMark.chapter_description,
    }));
};
